import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import * as Papi from '@app/papi';
import * as Cognito from '../cognito';
import { Helpers } from '../../helpers';

@Component({
	selector: 'app-logout',
	templateUrl: './logout.component.html',
	encapsulation: ViewEncapsulation.None,
	standalone: false
})

export class LogoutComponent implements OnInit {

	constructor(
		private router: Router,
		private papi: Papi.Service,
		private cognito: Cognito.CognitoService) {
	}

	ngOnInit(): void {
		Helpers.setLoading(true);
		// reset login status
		this.papi.logout();
		this.cognito.logout();
		this.router.navigate(['/login']);
	}
}